import * as React from "react"
import LazyImage from "../general/lazyImage"
import Translate from '../general/translate'

const ContactSection = () => {

  return (
    <div className="pb-32 bg-[#643ADA]" id="contact">
        <div className="mx-auto grid grid-cols-12 grid-flow-col pb-5 pt-24">
            <div className="col-span-10 col-start-2 lg:col-span-5 lg:col-start-2 text-center lg:text-left">
                <LazyImage src="/home/paperplane.webp" alt={<Translate id="contact.section.image.alt.sendMessage" foldername="home" filename="contactsection" />} className="h-[150px] lg:h-[200px] w-auto m-auto" />
            </div>
            <div className="col-span-10 col-start-2 lg:col-span-4 lg:col-start-7 container text-center lg:text-left">
                <p className="leading-tight text-[24px] font-bold text-[#fafafa] mt-[80px] mb-[40px]">
                    <Translate id="contact.section.title" foldername="home" filename="contactsection" />
                </p>
                <div className="h-1 bg-[#FFCA1D] w-[70px] m-auto lg:m-0"></div>
                <p className="leading-tight text-[18px] text-[#FAFAFA] mt-[40px] mb-10">
                    <Translate id="contact.section.email" foldername="home" filename="contactsection" />
                </p>
                <div className="text-[18px] text-[#fafafa] mt-5 mb-10">
                    <LazyImage src="/home/tiago.webp" alt={<Translate id="contact.section.image.alt.tiago" foldername="home" filename="contactsection" />} className="h-20 w-auto mx-auto lg:mx-0 mb-5" />
                    <a href="https://twitter.com/wbetiago" className="text-[#FFCA1D] font-bold cursor-pointer">
                        Tiago <span className="text-[#fafafa] font-medium"><Translate id="contact.section.tiago.role" foldername="home" filename="contactsection" /></span>
                    </a>
                </div>
                <div className="text-[18px] text-[#fafafa] mt-5">
                    <LazyImage src="/home/joao.webp" alt={<Translate id="contact.section.image.alt.joao" foldername="home" filename="contactsection" />} className="h-20 w-auto mx-auto lg:mx-0 mb-5" />
                    <a href="https://twitter.com/JOAOTHA" className="text-[#FFCA1D] font-bold cursor-pointer">
                        João <span className="text-[#fafafa] font-medium"><Translate id="contact.section.joao.role" foldername="home" filename="contactsection" /></span>
                    </a>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ContactSection